import { render, staticRenderFns } from "./login-dialog.vue?vue&type=template&id=49aa450e&scoped=true"
import script from "./login-dialog.vue?vue&type=script&lang=js"
export * from "./login-dialog.vue?vue&type=script&lang=js"
import style0 from "./login-dialog.vue?vue&type=style&index=0&id=49aa450e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49aa450e",
  null
  
)

export default component.exports